import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconEye = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 18'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M12.000,18.000 C4.205,18.000 0.000,11.612 0.000,9.000 C0.000,6.388 4.205,0.000 12.000,0.000 C19.795,0.000 24.000,6.388 24.000,9.000 C24.000,11.612 19.795,18.000 12.000,18.000 ZM12.000,2.000 C5.216,2.000 2.000,7.615 2.000,9.000 C2.000,10.385 5.216,16.000 12.000,16.000 C18.784,16.000 22.000,10.385 22.000,9.000 C22.000,7.615 18.784,2.000 12.000,2.000 ZM12.000,14.000 C9.243,14.000 7.000,11.757 7.000,9.000 C7.000,6.243 9.243,4.000 12.000,4.000 C14.757,4.000 17.000,6.243 17.000,9.000 C17.000,11.757 14.757,14.000 12.000,14.000 ZM12.000,6.000 C10.346,6.000 9.000,7.346 9.000,9.000 C9.000,10.654 10.346,12.000 12.000,12.000 C13.654,12.000 15.000,10.654 15.000,9.000 C15.000,7.346 13.654,6.000 12.000,6.000 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconEye.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
